export const errorMessages: Record<string, string> = {
  NOT_FOUND: 'Oops, that is not a valid code. Please try again.',
  ALREADY_USED: 'Oops, you can only use this voucher code once.',
  NOT_VALID_YET: 'Oops, this code is not valid yet.',
  NOT_VALID_ANYMORE: 'Oops, the voucher code has expired.',
};
